<template>
  <BaseFormInput
    v-model="displayDate"
    :validation="validation?.timestamp"
    :label="inputLabel"
    :disabled="disabled"
    placeholder="TT.MM.JJJJ"
    :test-id="testId ? testId : 'mounting-date'"
    inputmode="numeric"
    pattern="\d{2}\.\d{2}\.\d{4}"
  />
</template>
<script setup lang="ts">
import { computed, ref, watch, WritableComputedRef } from 'vue';
import BaseFormInput from '@/components/UI/Input/BaseFormInput.vue';
import { DeviceEventParams } from '@/models/installationPoint/DeviceEvent';
import { Validation } from '@vuelidate/core';

const props = defineProps<{
  deviceEvent: DeviceEventParams;
  validation?: Validation;
  disabled?: boolean;
  testId?: string;
  label?: string;
}>();
const emit = defineEmits(['update:deviceEvent']);

const localDeviceEvent: WritableComputedRef<DeviceEventParams> = computed({
  get() {
    return props.deviceEvent;
  },
  set(value) {
    emit('update:deviceEvent', value);
  },
});

function isoToGerman(iso: string): string {
  const [year, month, day] = iso.substr(0, 10).split('-');
  if (year && month && day) return `${day}.${month}.${year}`;
  return iso;
}

function germanToIso(german: string): string | null {
  const match = german.match(/^(\d{2})\.(\d{2})\.(\d{4})$/);
  if (!match) return null;
  return `${match[3]}-${match[2]}-${match[1]}`;
}

const displayDate = ref(isoToGerman(localDeviceEvent.value.timestamp));

const inputLabel = computed(() => {
  return props.label ? props.label : 'Montagedatum';
});

watch(
  () => displayDate.value,
  (value) => {
    const iso = germanToIso(value);
    if (iso) {
      localDeviceEvent.value.timestamp = iso + 'T08:00:00.000Z';
    }
  }
);
</script>
